/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  UpdateArtifactDto,
} from '../models/index';
import {
    UpdateArtifactDtoFromJSON,
    UpdateArtifactDtoToJSON,
} from '../models/index';

export interface ArtifactControllerUpdateRequest {
    artifactId: string;
    updateArtifactDto: UpdateArtifactDto;
}

/**
 * ArtifactsApi - interface
 * 
 * @export
 * @interface ArtifactsApiInterface
 */
export interface ArtifactsApiInterface {
    /**
     * 
     * @param {string} artifactId 
     * @param {UpdateArtifactDto} updateArtifactDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtifactsApiInterface
     */
    artifactControllerUpdateRaw(requestParameters: ArtifactControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    artifactControllerUpdate(requestParameters: ArtifactControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ArtifactsApi extends runtime.BaseAPI implements ArtifactsApiInterface {

    /**
     */
    async artifactControllerUpdateRaw(requestParameters: ArtifactControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['artifactId'] == null) {
            throw new runtime.RequiredError(
                'artifactId',
                'Required parameter "artifactId" was null or undefined when calling artifactControllerUpdate().'
            );
        }

        if (requestParameters['updateArtifactDto'] == null) {
            throw new runtime.RequiredError(
                'updateArtifactDto',
                'Required parameter "updateArtifactDto" was null or undefined when calling artifactControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/chat/artifacts/{artifactId}`;
        urlPath = urlPath.replace(`{${"artifactId"}}`, encodeURIComponent(String(requestParameters['artifactId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateArtifactDtoToJSON(requestParameters['updateArtifactDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async artifactControllerUpdate(requestParameters: ArtifactControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.artifactControllerUpdateRaw(requestParameters, initOverrides);
    }

}
